export const ErrorAlerts = {
    type: 'alert',
    showIcon: false,
    dismiss: {
      manually: false,
      automatically: true
    },
    appearance: 'light'
}
